<!--
  受講詳細
-->
<template>
  
  <h2 class="container my-4">
    受講詳細
  </h2>
  <nav class="container text-break text-muted align-middle">
    <span>
      <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/open_box${chapter.course.category.id}.gif`"
            draggable="false"
            class="w-auto max-hr-2 me-2" />
      <span>
        {{chapter.course.category.name}}
      </span>
    </span>
    <span class="mx-3">&gt;</span>
    <span>
      <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/open_book${chapter.course.category.id}.gif`"
            draggable="false"
            class="w-auto max-hr-2 me-2" />
      <span>
        {{chapter.course.name}}
      </span>
    </span>
  </nav>

  <section class="container my-4">
    <h4 class="d-flex my-2 align-items-center">
      <img :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/return_book${chapter.course.category.id}.gif`"
            draggable="false"
            class="w-auto max-hr-4 me-2" />
      <span>
        {{chapter.name}}
      </span>
    </h4>

    <div class="border rounded-3 p-4 max-hr-9 overflow-auto">
      {{chapter.overview}}
    </div>
  </section>

  <section class="container my-4" v-if="references != null && references.length > 0">
    <h6 class="my-2">
      参考資料
    </h6>
    <section class="border rounded-3">
      <div class="d-block m-2" v-for="r in references" :key="r.id">
        <svgicon v-if="r.fileContent == null"
                 name="box_arrow_up_right"
                 class="w-auto hr-1 me-2" />
        <svgicon v-if="r.fileContent != null"
                 name="download"
                 class="w-auto hr-1 me-2" />
        <a href="#">
          <span>
            {{r.displayString}}
          </span>
        </a>
      </div>
    </section>
  </section>

  <section class="container my-4" v-if="contents.length">
    <h6 class="my-2">
      コンテンツ
    </h6>
    <a class="border rounded-3 my-2 p-2 d-flex position-relative mb-5 text-decoration-none text-dark"
             v-for="c in contentsList" :key="c.id"
            :href="'/Contents?id=' + c.id"
             role="button">
      <svgicon v-if="c.contentsType == 'test'" name="pencil_square"
               class="w-auto hr-3 m-2 me-4"
               :class="{'opacity-50': getRandomBool()}" />
      <svgicon v-else-if="c.contentsType == 'movie'" name="file_earmark_play"
               class="w-auto hr-3 m-2 me-4"
               :class="{'opacity-50': getRandomBool()}" />
      <svgicon v-else-if="c.contentsType == 'music'" name="file_earmark_music"
               class="w-auto hr-3 m-2 me-4"
               :class="{'opacity-50': getRandomBool()}" />
      <svgicon v-else name="file_earmark_text"
               class="w-auto hr-3 m-2 me-4"
               :class="{'opacity-50': getRandomBool()}" />
      <div class="flex-grow-1"
           :class="{'opacity-50': c.attendable == false}">
        <div class="small fw-bold text-muted border-bottom pb-1 mb-1">
          {{
            c.contentsType == "test" ? "テスト" :
            c.contentsType == "questionnaire" ? "アンケート" :
            c.contentsType == "music" ? "閲覧コンテンツ : 音声" :
            c.contentsType == "movie" ? "閲覧コンテンツ : 動画" :
            c.contentsType == "pdf" ? "閲覧コンテンツ : PDF" :
            c.contentsType == "word" ? "閲覧コンテンツ : WORD" :
            c.contentsType == "excel" ? "閲覧コンテンツ : EXCEL" :
            c.contentsType == "ppt" ? "閲覧コンテンツ : スライド" :
            c.contentsType == "url" ? "閲覧コンテンツ : 外部コンテンツ" :
            c.contentsType == "pledge" ? "誓約書" :
            c.contentsType == "task" ? "提出コンテンツ " :
            c.contentsType == "certificate" ? "修了証" :
            "閲覧コンテンツ : テキスト"
          }}
        </div>
        <span class="d-block">
          {{c.displayString}}
        </span>

        <progress-bar class="mt-1 small"
                      :value="getRandomInt()"
                      :size="0.75" />

      </div>

      <div class="detail-tab border border-top-0">
        <button class="btn btn-link dropdown-toggle">
          詳細
        </button>
      </div>
    </a>
  </section>

  <section class="container my-4">
    <a class="btn btn-outline-success" href="/Courses">
      戻る
    </a>
  </section>

</template>

<style>
  .detail-tab {
    position: absolute;
    top: 100%;
    background: white;
    border-radius: 0 0 0.5rem 0.5rem;
    right: 1rem;
    border-top: white !important;
  }
</style>

<script>
  import { defineComponent } from "vue";
  import { xhrRequest, xhrErrors } from "utils/xhr";
  import Spinner from "utils/spinner";
  import { format } from 'date-fns';
  import validationErrors from "components/base/validation_errors";

  import ProgressBarControl from "components/control/progress_bar_control";

  const onInit = () => {

  };

  const onMounted = function () {
    this.loadContents();
  };

  const methods = {
    loadContents() {
      xhrRequest(
        "GET",
        "contents",
        null,
        {
          success: data => {
            this.contents = data.contents;
          },
          error: (xhr, status, error) => {
          },
          complete: () => {
          },
        },
      );
      xhrRequest(
        "GET",
        "contents/reference",
        null,
        {
          success: data => {
            this.references = data.contents;
          },
          error: (xhr, status, error) => {
          },
          complete: () => {
          },
        },
      );
    },
    getRandomInt() {
      return parseInt(Math.random() * 100);
    },
    getRandomBool() {
      return parseInt(Math.random() * 100) > 50;
    },
  };

  const computed = {
    contentsList: function () {
      if (this.contents.length) {
        return this.contents.filter(c => c.contentsType != "reference");
      }
    },
    referenceList: function () {
      if (this.contents.length) {
        return this.contents.filter(c => c.contentsType == "reference");
      }
    },
  };

  export default defineComponent({
    template: "#container",
    data: () => {
      return {
        contents: [],
        references: [],
        chapter: {
          id: 1,
          name: "チャプター（章） No.1 - 1 - 1",
          progress: 100,
          overview: "チャプター（章） No.1 - 1 - 1 の概要です。チャプター（章） No.1 - 1 - 1 の概要です。チャプター（章） No.1 - 1 - 1 の概要です。チャプター（章） No.1 - 1 - 1 の概要です。チャプター（章） No.1 - 1 - 1 の概要です。チャプター（章） No.1 - 1 - 1 の概要です。",
          course: {
            id: 1,
            name: "コース No.1 - 1",
            progress: 60,
            overview: "コース No.1 - 1 の概要です。",
            category: {
              id: 1,
              name: "カテゴリ（分類） No.1",
              progress: 75,
              overview: "カテゴリ（分類） No.1 の概要です。",
            },
          },
          contents: [
            {
              id: 1,
              type: "pdf",
              name: "PDFコンテンツ -- チャプター（章） No.1 - 1 - 1",
              status: "attended",
              progress: 100,
              playback: 32,
              attendable: true,
            },
            {
              id: 2,
              type: "movie",
              name: "動画コンテンツ -- チャプター（章） No.1 - 1 - 1",
              status: "attending",
              progress: 80,
              playback: 5563,
              attendable: true,
            },
            {
              id: 3,
              type: "test",
              name: "確認テスト -- チャプター（章） No.1 - 1 - 1",
              status: "notAttended",
              progress: 0,
              attendable: false,
            },
            {
              id: 4,
              type: "pdf",
              name: "PDFコンテンツ -- チャプター（章） No.1 - 1 - 1",
              status: "notAttended",
              progress: 0,
              attendable: false,
            },
          ],
          references: [
            {
              id: 1,
              name: "参考資料 1 - 1 - 1 - 1",
              type: "url",
            },
            {
              id: 2,
              name: "参考資料 1 - 1 - 1 - 2",
              type: "file",
            },
            {
              id: 3,
              name: "参考資料 1 - 1 - 1 - 3",
              type: "file",
            },
          ],
        },
      }
    },
    created: onInit,
    mounted: onMounted,
    methods: methods,
    computed: computed,
    components: {
      "progress-bar": ProgressBarControl,
    },
  });
</script>
